import { useContext } from 'react';
import PurchaseOrderManagementContext from '../contexts/PurchaseOrderManagementContext';

const useInvalidatePurchaseOrder = () => {
  const { invalidate } = useContext(PurchaseOrderManagementContext);
  return invalidate;
};

export default useInvalidatePurchaseOrder;
